module.exports = "/_next/static/images/slide4-bc08ff1ae92431b6d81f892813285988.jpg.webp";